import ga from "@starter/Framework/Common/GoogleAnalytics";

const mapOptions = (options?: Toolkit.GoogleAnalytics.Options): Toolkit.GoogleAnalytics.Event => {
    if (options) {
        if (options.invoice) {
            return ga.map.invoiceOption(options);
        }

        if (options.order) {
            return ga.map.orderOption(options);
        }

        if (options.wishList) {
            return ga.map.wishListOption(options);
        }

        if (options.quote) {
            return ga.map.quoteOption(options);
        }

        if (options.cart) {
            return ga.map.cartOption(options);
        }
    }

    return {};
};

export default mapOptions;
